var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 231,
    viewBox: "0 0 475 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.259,
    width: 163,
    height: 163,
    transform: "rotate(45 115.259 0)",
    fill: "url(#paint0_linear_160_7)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.017,
    width: 163,
    height: 163,
    transform: "rotate(45 158.017 0)",
    fill: "url(#paint1_linear_160_7)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199.017,
    width: 163,
    height: 163,
    transform: "rotate(45 199.017 0)",
    fill: "url(#paint2_linear_160_7)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 239.017,
    width: 163,
    height: 163,
    transform: "rotate(45 239.017 0)",
    fill: "url(#paint3_linear_160_7)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 279.017,
    width: 163,
    height: 163,
    transform: "rotate(45 279.017 0)",
    fill: "url(#paint4_linear_160_7)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 319.017,
    width: 163,
    height: 163,
    transform: "rotate(45 319.017 0)",
    fill: "url(#paint5_linear_160_7)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 359.017,
    width: 163,
    height: 163,
    transform: "rotate(45 359.017 0)",
    fill: "url(#paint6_linear_160_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_7",
    x1: 215.614,
    y1: -88.0348,
    x2: 108.642,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_7",
    x1: 258.372,
    y1: -88.0348,
    x2: 151.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_7",
    x1: 299.372,
    y1: -88.0348,
    x2: 192.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_160_7",
    x1: 339.372,
    y1: -88.0348,
    x2: 232.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_160_7",
    x1: 379.372,
    y1: -88.0348,
    x2: 272.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_160_7",
    x1: 419.372,
    y1: -88.0348,
    x2: 312.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_160_7",
    x1: 459.372,
    y1: -88.0348,
    x2: 352.399,
    y2: 14.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35);
export default __webpack_public_path__ + "static/media/group-35.76995c7f3c6a83ebf0ac08e1b10d6fcc.svg";
export { ForwardRef as ReactComponent };